import { browserStorage, defineStorageEntry, stringStorageCodec } from "@/lib/browserStorage";

export const OPENAI_API_URL = "https://api.openai.com/v1/chat/completions";
export const OPENAI_KEY_STORAGE_KEY = "webIngestion.openaiKey";

const openAIKeyEntry = defineStorageEntry({
  area: "session",
  key: OPENAI_KEY_STORAGE_KEY,
  codec: stringStorageCodec,
});

export const getOpenAIKey = (): string | null => {
  return browserStorage.get(openAIKeyEntry);
};

export const setOpenAIKey = (key: string): void => {
  browserStorage.set(openAIKeyEntry, key);
};

export const hasOpenAIKey = (): boolean => {
  return !!getOpenAIKey();
};
